import SkipToMainContent from './SkipToMainContent'

export default SkipToMainContent
